import { Injectable } from '@angular/core';
import { NetworkManager } from 'src/app/managers/network/network.manager';
import { HttpHeaders } from '@angular/common/http';
import { RequestField } from 'src/app/enums/network/request/requestField.enum';
import { CQWebappApi } from 'src/app/enums/network/request/cqwebapp/cqwebappApi.enum';

@Injectable({
  providedIn: 'root',
})
export class AppRouterRequest {
  constructor(private network: NetworkManager) {}

  getAppRouter(
    platform: string,
    protocol: string,
    base_url: string,
    code: string,
  ) {
    let url = this.network.CodaQApi() + CQWebappApi.APP_ROUTER;

    const form = new URLSearchParams();
    form.set(RequestField.PLATFORM, platform);
    if (protocol) form.set(RequestField.PROTOCOL, protocol);

    form.set(RequestField.URL, base_url);
    form.set(RequestField.CODE, code);

    return this.network.http().put(url, form.toString(), {});
  }
}
